var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-alert-red"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-alert-red",
    clipPath: "url(#clip-icon-alert-red)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(-482 -628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    transform: "translate(482 628)",
    fill: "red",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle",
    "data-name": "Icon feather-alert-triangle",
    transform: "translate(482.333 626.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M7.189,4.881,2.477,12.747a1.113,1.113,0,0,0,.951,1.669h9.423a1.113,1.113,0,0,0,.951-1.669L9.091,4.881a1.113,1.113,0,0,0-1.9,0Z",
    transform: "translate(1.339 0.859)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M.738-2.123h-1.5L-1-6.3H.971Zm.3,1.34a.818.818,0,0,1-.283.642A1.1,1.1,0,0,1,0,.11,1.1,1.1,0,0,1-.754-.145a.811.811,0,0,1-.292-.637.781.781,0,0,1,.283-.626A1.143,1.143,0,0,1,0-1.648a1.14,1.14,0,0,1,.754.24A.776.776,0,0,1,1.042-.782Z",
    transform: "translate(492 641)",
    fill: "red"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertRed);
export default __webpack_public_path__ + "static/media/icon-alert-red.8a7ee91cc04c5058dabc4926c9ed9273.svg";
export { ForwardRef as ReactComponent };